export const truthy: (v: unknown) => boolean = (v) => {
  if (typeof v === 'string') {
    return String(v || '').toLowerCase() === 'true'
  }
  if (typeof v === 'boolean') {
    return v
  }
  return false
}

export default truthy
